import { render, staticRenderFns } from "./SubjectLineTokenField.vue?vue&type=template&id=140a37af&scoped=true"
import script from "./SubjectLineTokenField.vue?vue&type=script&lang=ts"
export * from "./SubjectLineTokenField.vue?vue&type=script&lang=ts"
import style0 from "./SubjectLineTokenField.vue?vue&type=style&index=0&id=140a37af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a37af",
  null
  
)

export default component.exports